import { oysterTheme } from '@yaydoo/react-components/lib/theme';

export const coBrandingDefaultValues = {
  primaryColor: oysterTheme.pine,
  secondaryColor: oysterTheme.oyster,
};
